import { FlatSteps, PaymentStatus } from '@src/constants';

export const sendFlatProgress = (stepFlat: number, status?: PaymentStatus) => {
  if (stepFlat === FlatSteps.PAYMENT_RESULT) {
    window.parent.postMessage({ stepFlat, status }, '*');
  } else {
    window.parent.postMessage({ stepFlat }, '*');
  }
};
